<!-- serverside-alert component -->
<ng-container *ngIf="alertReported">
    <div 
        class="serverside-alert" 
        [style.background-color]="this.backgroundColor"
    >
        <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
                <circle cx="25" cy="25" r="20" [attr.fill]="this.color" />
                <text x="25" y="32.5" text-anchor="middle" font-size="24" fill="white">&#9888;</text>
            </svg>
        </div>
        <div class="messages">
            <div *ngFor="let message of messages">
                <span [style.color]="this.color">{{message}}</span>
            </div>
        </div>
    </div>
</ng-container>